import React, { useState } from 'react';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';
import { FaUserShield, FaUserCog, FaUsers, FaPlus, FaBan, FaExchangeAlt, FaTrash, FaLaptop, FaSitemap, FaCheck } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import toast, { Toaster } from 'react-hot-toast';

export default function AdminConsole() {
  // ---------- Forced styles ----------
  const S = {
    page: { display:'flex', background:'#0b1320', color:'#fff', minHeight:'100vh' },
    main: { padding:'16px', paddingTop:'24px', width:'100%' },
    headerWrap: {
      backdropFilter:'blur(6px)',
      background:'linear-gradient(135deg, rgba(35,39,47,.85) 0%, rgba(24,27,32,.85) 100%)',
      border:'1px solid rgba(255,255,255,.08)',
      borderRadius:16,
      padding:'12px 16px',
      marginBottom:24,
      display:'flex',
      alignItems:'center',
      gap:12,
      boxShadow:'0 18px 44px -28px rgba(0,0,0,.6)'
    },
    headerBadge:{ background:'#4f46e5', borderRadius:12, padding:8, display:'grid', placeItems:'center', boxShadow:'0 10px 24px -10px rgba(79,70,229,.6)' },
    headerTitle:{ fontSize:18, fontWeight:800, letterSpacing:.3 },
    headerSub:{ color:'rgba(255,255,255,.55)', fontWeight:500, marginLeft:6 },

    quickBtn: {
      background:'#171b22',
      border:'1px solid rgba(255,255,255,.08)',
      padding:'10px 14px',
      borderRadius:12,
      display:'inline-flex',
      alignItems:'center',
      gap:8,
      fontWeight:700,
      color:'#e8eefc',
      textDecoration:'none',
      boxShadow:'0 10px 30px -22px rgba(0,0,0,.6)',
      transition:'transform .15s ease'
    },

    panel: {
      background:'linear-gradient(180deg, #11151b 0%, #0c1118 100%)',
      border:'1px solid rgba(255,255,255,.08)',
      borderRadius:18,
      padding:14,
      boxShadow:'0 24px 60px -36px rgba(0,0,0,.7)'
    },
    addBtnWrap:{ display:'flex', justifyContent:'end', marginBottom:8 },
    addBtn:{
      background:'#2563eb',
      border:'1px solid rgba(255,255,255,.12)',
      color:'#fff',
      borderRadius:999,
      padding:10,
      display:'grid',
      placeItems:'center',
      boxShadow:'0 18px 32px -18px rgba(37,99,235,.7)',
      cursor:'pointer',
      transition:'transform .15s ease'
    },

    roleBlock: { marginBottom:28 },
    roleTitle:{ fontSize:16, fontWeight:800, letterSpacing:.2 },

    card:{
      background:'#151a22',
      border:'1px solid rgba(255,255,255,.08)',
      borderRadius:14,
      boxShadow:'0 20px 50px -36px rgba(0,0,0,.65)',
      display:'flex',
      flexDirection:'column',
      overflow:'hidden'
    },
    cardTop:{
      display:'flex',
      flexDirection:'column',
      gap:8,
      padding:'10px 12px'
    },
    cardTopRow:{
      display:'flex',
      alignItems:'center',
      justifyContent:'space-between',
      gap:10
    },
    avatar:{
      background:'#0e1218',
      color:'#fff',
      borderRadius:999,
      width:30,
      height:30,
      display:'grid',
      placeItems:'center',
      fontWeight:800,
      fontSize:14,
      border:'1px solid rgba(255,255,255,.06)'
    },
    nameWrap:{ display:'flex', alignItems:'center', gap:10 },
    nameBlock:{ display:'flex', flexDirection:'column', lineHeight:1.1 },
    name:{ fontWeight:700, color:'#fff', fontSize:14 },
    active:{ display:'flex', alignItems:'center', gap:6, color:'#34d399', fontSize:11, fontWeight:700, marginTop:2 },
    meta:{ color:'rgba(255,255,255,.65)', fontSize:12 },

    cardBottom:{
      display:'flex',
      flexWrap:'wrap',
      gap:8,
      background:'#0f141b',
      borderTop:'1px solid rgba(255,255,255,.06)',
      padding:'8px 12px',
      borderRadius:'0 0 14px 14px',
      justifyContent:'flex-end'
    },
    smallBtn:(bg, bdr, color='#e8eefc')=>({
      display:'inline-flex',
      alignItems:'center',
      justifyContent:'center',
      gap:6,
      padding:'6px 10px',
      borderRadius:10,
      background:bg,
      border:bdr,
      color,
      fontSize:12,
      fontWeight:700,
      cursor:'pointer',
      transition:'filter .15s ease'
    }),

    // Modals
    overlay:{ position:'fixed', inset:0, background:'rgba(0,0,0,.6)', backdropFilter:'blur(3px)', display:'grid', placeItems:'center', zIndex:50, padding:16 },
    modal:{
      background:'#0f141b',
      border:'1px solid rgba(255,255,255,.1)',
      borderRadius:16,
      width:'100%',
      maxWidth:560,
      boxShadow:'0 40px 100px -36px rgba(0,0,0,.8)',
      position:'relative',
      padding:18,
      maxHeight:'90vh',
      overflowY:'auto'
    },
    closeX:{ position:'absolute', top:10, right:14, color:'rgba(255,255,255,.75)', fontSize:26, cursor:'pointer' },

    modalHead:{ display:'flex', alignItems:'center', gap:10, marginBottom:12 },
    modalBadge:(bg)=>({ background:bg, padding:8, borderRadius:12, display:'grid', placeItems:'center' }),
    modalTitle:{ fontWeight:800, color:'#fff', fontSize:18 },
    modalSub:{ color:'rgba(255,255,255,.6)' },

    label:{ display:'block', color:'#fff', fontWeight:700, marginBottom:6, fontSize:13 },
    input:{
      width:'100%', background:'#0b1220', border:'1px solid rgba(255,255,255,.12)', color:'#fff',
      borderRadius:12, padding:'10px 12px', outline:'none'
    },
    select:{
      width:'100%', background:'#0b1220', border:'1px solid rgba(255,255,255,.12)', color:'#fff',
      borderRadius:12, padding:'10px 12px', outline:'none'
    },
    primaryCTA:{
      width:'100%', marginTop:12, background:'#4f46e5', color:'#fff', fontWeight:800,
      border:'1px solid rgba(255,255,255,.12)', padding:'12px 14px', borderRadius:14,
      boxShadow:'0 20px 44px -22px rgba(79,70,229,.7)', cursor:'pointer'
    },
    warnCTA:{
      width:'100%', marginTop:12, background:'#f59e0b', color:'#0b1020', fontWeight:800,
      border:'1px solid rgba(255,255,255,.12)', padding:'12px 14px', borderRadius:14, cursor:'pointer'
    },
    errorText:{ color:'#fca5a5', fontWeight:700, fontSize:12 },

    // Role grid responsiveness still by className grid; visuals here:
    gridWrap:{},
  };

  // Get user info from localStorage
  const user = JSON.parse(localStorage.getItem('user')) || {
    name: 'Unknown User',
    role: 'Member',
    image: '/user.png',
  };

  const [showAddMember, setShowAddMember] = useState(false);
  const [position, setPosition] = useState('');
  const [studentId, setStudentId] = useState('');
  const [addLoading, setAddLoading] = useState(false);
  const [addError, setAddError] = useState('');

  const [membersByRole, setMembersByRole] = useState({});
  const [membersLoading, setMembersLoading] = useState(false);
  const [membersError, setMembersError] = useState('');

  // Fetch all members and group by role
  async function fetchMembers() {
    setMembersLoading(true);
    setMembersError('');
    try {
      const response = await fetch('https://dev.sliitleo.org/Backend/rolechange.php');
      if (!response.ok) throw new Error('Failed to fetch members');
      const members = await response.json();
      // Group by role
      const grouped = {};
      members.forEach(m => {
        const role = m.Role || 'Unassigned';
        if (!grouped[role]) grouped[role] = [];
        grouped[role].push(m);
      });
      setMembersByRole(grouped);
    } catch (err) {
      setMembersError(err.message);
    } finally {
      setMembersLoading(false);
    }
  }

  React.useEffect(() => {
    fetchMembers();
  }, []);

  async function handleAddMember(e) {
    e.preventDefault();
    setAddError('');
    if (!position || !studentId) {
      setAddError('Please fill all fields');
      return;
    }
    setAddLoading(true);
    try {
      const response = await fetch('https://dev.sliitleo.org/Backend/rolechange.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({
          studentId,
          role: position
        })
      });
      const data = await response.json();
      if (data.success) {
        setShowAddMember(false);
        setStudentId('');
        setPosition('');
        toast.success('Role updated successfully!', {
          duration: 4000,
          position: 'top-center',
          style: {
            background: '#10B981',
            color: '#fff',
            padding: '12px 20px',
            borderRadius: '8px',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
          }
        });
        fetchMembers(); // Refresh list
      } else {
        const errorMsg = data.error || data.message || 'Failed to update role.';
        setAddError(errorMsg);
        toast.error(errorMsg, {
          duration: 5000,
          position: 'top-center',
          style: {
            background: '#EF4444',
            color: '#fff',
            padding: '12px 20px',
            borderRadius: '8px',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
          }
        });
      }
    } catch (err) {
      setAddError('Server error: ' + err.message);
    } finally {
      setAddLoading(false);
    }
  }

  // State for Change Role modal
  const [showChangeRole, setShowChangeRole] = useState(false);
  const [changeRoleMember, setChangeRoleMember] = useState(null);
  const [changeRoleValue, setChangeRoleValue] = useState("");
  const [changeRoleLoading, setChangeRoleLoading] = useState(false);
  const [changeRoleError, setChangeRoleError] = useState("");
  const [banConfirmation, setBanConfirmation] = useState(null);

  const [showBanConfirm, setShowBanConfirm] = useState(false);
  const [userToBan, setUserToBan] = useState(null);
  const [isBanning, setIsBanning] = useState(false);

  function openChangeRoleModal(member) {
    setChangeRoleMember(member);
    setChangeRoleValue(member.Role || member.role || "");
    setShowChangeRole(true);
    setChangeRoleError("");
  }
  function closeChangeRoleModal() {
    setShowChangeRole(false);
    setChangeRoleMember(null);
    setChangeRoleValue("");
    setChangeRoleError("");
  }

  async function updateUserRole(studentId, role, memberName = '') {
    const loadingToast = toast.loading('Updating role...', {
      position: 'top-center'
    });
    
    try {
      const response = await fetch('https://dev.sliitleo.org/Backend/rolechange.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({
          studentId,
          role
        })
      });
      const data = await response.json();
      
      if (data.success) {
        const successMessage = memberName 
          ? `Successfully updated ${memberName}'s role to ${role}`
          : 'Role updated successfully!';
          
        toast.dismiss(loadingToast);
        toast.success(successMessage, {
          duration: 4000,
          position: 'top-center',
          style: {
            background: '#10B981',
            color: '#fff',
            padding: '12px 20px',
            borderRadius: '8px',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
          }
        });
        
        fetchMembers();
        return true;
      } else {
        const errorMsg = data.error || data.message || 'Failed to update role.';
        toast.dismiss(loadingToast);
        toast.error(errorMsg, {
          duration: 5000,
          position: 'top-center',
          style: {
            background: '#EF4444',
            color: '#fff',
            padding: '12px 20px',
            borderRadius: '8px',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
          }
        });
        return false;
      }
    } catch (err) {
      alert('Server error: ' + err.message);
      return false;
    }
  }

  async function handleChangeRoleSubmit(e) {
    e.preventDefault();
    setChangeRoleError("");
    if (!changeRoleValue) {
      setChangeRoleError("Please select a role");
      return;
    }
    setChangeRoleLoading(true);
    const success = await updateUserRole(changeRoleMember.SLIITID, changeRoleValue);
    if (success) {
      closeChangeRoleModal();
    }
    setChangeRoleLoading(false);
  }

  async function handleMakeClubMember(member) {
    const confirmMessage = `Are you sure you want to make ${member.FullName} a Club Member?`;
    
    const userConfirmed = await new Promise((resolve) => {
      toast((t) => (
        <div className="text-center">
          <p className="mb-4 text-gray-800">{confirmMessage}</p>
          <div className="flex justify-center gap-4">
            <button
              onClick={() => {
                toast.dismiss(t.id);
                resolve(true);
              }}
              className="px-4 py-2 bg-green-500 text-white rounded-lg hover:bg-green-600 transition-colors"
            >
              Yes, Update
            </button>
            <button
              onClick={() => {
                toast.dismiss(t.id);
                resolve(false);
              }}
              className="px-4 py-2 bg-gray-300 text-gray-800 rounded-lg hover:bg-gray-400 transition-colors"
            >
              Cancel
            </button>
          </div>
        </div>
      ), {
        duration: 10000,
        style: {
          minWidth: '300px',
          padding: '16px',
          borderRadius: '12px',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
        }
      });
    });

    if (userConfirmed) {
      await updateUserRole(member.SLIITID, 'Club Member', member.FullName);
    }
  }

  const handleBanUser = async (member) => {
    setUserToBan(member);
    setShowBanConfirm(true);
  };

  const confirmBan = async () => {
    if (!userToBan) return;
    
    const toastId = toast.loading('Banning user...');
    setBanConfirmation(userToBan.SLIITID);
    setIsBanning(true);
    
    try {
      const formData = new URLSearchParams();
      formData.append('studentId', userToBan.SLIITID);
      formData.append('role', 'Banned');

      let response;
      try {
        response = await fetch('https://dev.sliitleo.org/Backend/rolechange.php', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: formData,
          credentials: 'include'
        });
      } catch (error) {
        response = await fetch('https://dev.sliitleo.org/Backend/rolechange.php', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: formData
        });
      }

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || 'Failed to ban user');
      }

      const data = await response.json();
      if (data.success) {
        toast.success(`Successfully Banned ${userToBan.Name || userToBan.name || 'the user'}`, { id: toastId });
        setTimeout(() => window.location.reload(), 1000);
      } else {
        throw new Error(data.error || 'Failed to ban user');
      }
    } catch (error) {
      console.error('Error banning user:', error);
      toast.error(error.message || 'Failed to ban user', { id: toastId });
    } finally {
      setBanConfirmation(null);
      setIsBanning(false);
      setShowBanConfirm(false);
      setUserToBan(null);
    }
  };

  const BanConfirmationModal = () => {
    if (!showBanConfirm) return null;
    return (
      <div style={S.overlay}>
        <div style={{ ...S.modal, border:'1px solid rgba(239,68,68,.3)' }}>
          <button style={S.closeX} onClick={()=>{ setShowBanConfirm(false); setUserToBan(null); }} aria-label="Close">&times;</button>
          <div style={S.modalHead}>
            <div style={S.modalBadge('rgba(239,68,68,.12)')}>
              <FaBan style={{ color:'#f87171', fontSize:20 }} />
            </div>
            <div>
              <div style={S.modalTitle}>Confirm Ban</div>
              <div style={{ ...S.modalSub, fontSize:12 }}>This action cannot be undone</div>
            </div>
          </div>

          <p style={{ color:'rgba(255,255,255,.8)', marginBottom:18 }}>
            Are you sure you want to ban <span style={{ fontWeight:700, color:'#fff' }}>
              {userToBan?.Name || userToBan?.name || 'this user'}
            </span>? This will revoke their access to the portal.
          </p>

          <div style={{ display:'flex', gap:10, justifyContent:'flex-end' }}>
            <button
              onClick={() => { setShowBanConfirm(false); setUserToBan(null); }}
              disabled={isBanning}
              style={{ ...S.smallBtn('rgba(255,255,255,.08)','1px solid rgba(255,255,255,.1)'), padding:'10px 14px' }}
            >
              Cancel
            </button>
            <button
              onClick={confirmBan}
              disabled={isBanning}
              style={{ ...S.smallBtn('#ef4444','1px solid rgba(255,255,255,.12)', '#fff'), padding:'10px 14px' }}
            >
              {isBanning ? 'Banning…' : (<><FaBan/> <span>Yes, Ban User</span></>)}
            </button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div style={S.page}>
      <Toaster />
      <Sidebar />
      <Topbar user={user} />

      <main className="md:ml-64 ml-0 mt-14 w-full" style={S.main}>
        {/* Add Member Modal */}
        {showAddMember && (
          <div style={S.overlay}>
            <div style={S.modal}>
              <button style={S.closeX} onClick={() => setShowAddMember(false)} aria-label="Close">&times;</button>
              <div style={S.modalHead}>
                <span style={S.modalBadge('#2563eb')}>
                  <FaUserCog style={{ color:'#fff', fontSize:18 }} />
                </span>
                <span style={S.modalTitle}>Role Management</span>
                <span style={{ ...S.modalSub, marginLeft:6 }}>/ Add Member</span>
              </div>

              <form className="space-y-4" onSubmit={handleAddMember}>
                <div>
                  <label style={S.label}>Select Position</label>
                  <select
                    style={S.select}
                    value={position}
                    onChange={e => setPosition(e.target.value)}
                    disabled={addLoading}
                  >
                    <option value="">Select Position</option>
                    
                    <option value="System Admin">System Admin</option>
                    <option value="President">President</option>
                    <option value="Vice President">Vice President</option>
                    <option value="Secretary">Secretary</option>
                    <option value="Treasurer">Treasurer</option>
                    <option value="Co - Asst. Secretary">Co - Asst. Secretary</option>
                    <option value="Co - Asst. Treasurer">Co - Asst. Treasurer</option>
                    <option value="Chief Editor">Chief Editor</option>
                    <option value="President Program Coordinator">President Program Coordinator</option>
                    <option value="Club Performence Evaluator">Club Performence Evaluator</option>
                    <option value="Club Director">Club Director</option>
                    <option value="Team Head">Team Head</option>
                    <option value="Activity Director">Activity Director</option>
                    <option value="Past President">Past President</option>
                    <option value="Past Board Member">Past Board Member</option>
                    <option value="IT Department">IT Department</option>
                    <option value="Installation sub-committee member">Installation sub-committee member</option>
                    <option value="Reporting Sub-Committee">Reporting Sub-Committee</option>
                    <option value="Committee Member">Committee Member</option>
                  </select>
                </div>

                <div>
                  <label style={S.label}>Student ID</label>
                  <input
                    style={S.input}
                    type="text"
                    placeholder="Student ID"
                    value={studentId}
                    onChange={e => setStudentId(e.target.value)}
                    disabled={addLoading}
                  />
                </div>

                {addError && <div style={S.errorText}>{addError}</div>}

                <button type="submit" style={S.primaryCTA} disabled={addLoading}>
                  {addLoading ? 'Adding...' : 'Add Member'}
                </button>
              </form>
            </div>
          </div>
        )}

        {/* Header */}
        <div style={S.headerWrap}>
          <span style={{ display:'flex', alignItems:'center', gap:12 }}>
            <span style={S.headerBadge}><FaUserShield className="text-2xl" style={{ color:'#fff' }}/></span>
            <span style={S.headerTitle}>
              Admin Console <span style={S.headerSub}>/ Member Management</span>
            </span>
          </span>
        </div>

        {/* Management Buttons */}
        <div className="flex flex-wrap gap-2 sm:gap-3 md:gap-4" style={{ marginBottom:24 }}>
          <Link to="/admin" style={S.quickBtn}><FaUserCog style={{ color:'#93c5fd' }}/> Role Management</Link>
          <Link to="/session-management" style={S.quickBtn}><FaUsers style={{ color:'#a78bfa' }}/> Session Management</Link>
          <Link to="/device-management" style={S.quickBtn}><FaLaptop style={{ color:'#a78bfa' }}/> Device Management</Link>
          <Link to="/path-management" style={S.quickBtn}><FaSitemap style={{ color:'#a78bfa' }}/> Role Path Management</Link>
        </div>

        {/* Main Panel */}
        <div style={S.panel}>
          {/* Add Member Floating Button */}
          <div style={S.addBtnWrap}>
            <button style={S.addBtn} onClick={() => setShowAddMember(true)} aria-label="Add Member">
              <FaPlus />
            </button>
          </div>

          {[
            
            "System Admin",
            "President",
            "Vice President",
            "Secretary",
            "Treasurer",
            "Co - Asst. Secretary",
            "Co - Asst. Treasurer",
            "Chief Editor",
           "President Program Coordinator",
            "Club Performence Evaluator",
           "Club Director",
            "Team Head",
            "Activity Director",
            "Past President",
            "Past Board Member",
            "IT Department",
            "Installation sub-committee member",
            "Reporting Sub-Committee",
            "Committee Member",
            "Banned"
          ].map(role => (
            <div key={role} style={S.roleBlock}>
              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:10 }}>
                <h2 style={S.roleTitle}>{role}(s)</h2>
              </div>

              {membersLoading ? (
                <div style={{ color:'rgba(255,255,255,.6)', marginBottom:16, marginLeft:4 }}>Loading...</div>
              ) : membersError ? (
                <div style={{ color:'#fca5a5', marginBottom:16, marginLeft:4 }}>{membersError}</div>
              ) : (membersByRole[role] && membersByRole[role].length > 0 ? (
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 sm:gap-4">
                  {membersByRole[role].map(member => (
                    <div key={member.SLIITID} style={S.card}>
                      <div style={S.cardTop}>
                        <div style={S.cardTopRow}>
                          <div style={S.nameWrap}>
                            <span style={S.avatar}>{member.FullName ? member.FullName[0] : '?'}</span>
                            <div style={S.nameBlock}>
                              <span style={S.name}>{member.FullName}</span>
                              <span style={S.active}><span style={{ fontSize:18, lineHeight:1 }}>●</span> Active</span>
                            </div>
                          </div>
                          <div style={{ ...S.meta, textAlign:'right' }}>
                            <div>SLIIT ID: {member.SLIITID}</div>
                            <div>Club ID: LCSM{member.SLIITLeoID}</div>
                          </div>
                        </div>
                      </div>

                      <div style={S.cardBottom}>
                        <button
                          style={S.smallBtn( banConfirmation === member.SLIITID ? '#9f1239' : '#7f1d1d', '1px solid rgba(255,255,255,.08)', '#fecaca')}
                          onClick={() => setUserToBan(member) || setShowBanConfirm(true)}
                        >
                          {banConfirmation === member.SLIITID ? (<><FaCheck/> Confirm Ban</>) : (<><FaBan/> Ban</>)}
                        </button>

                        <button
                          style={S.smallBtn('#111f35','1px solid rgba(59,130,246,.35)','#bfdbfe')}
                          onClick={() => handleMakeClubMember(member)}
                        >
                          <FaUserCog/> Make Member
                        </button>

                        <button
                          style={S.smallBtn('#2a1f07','1px solid rgba(234,179,8,.35)','#fde68a')}
                          onClick={() => openChangeRoleModal(member)}
                        >
                          <FaExchangeAlt/> Change Role
                        </button>

                        <button
                          style={S.smallBtn('#3f0f12','1px solid rgba(248,113,113,.3)','#fecaca')}
                        >
                          <FaTrash/> Remove
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div style={{ color:'rgba(255,255,255,.6)', marginBottom:16, marginLeft:4 }}>No users found</div>
              ))}
            </div>
          ))}
        </div>

        {/* Change Role Modal */}
        {showChangeRole && changeRoleMember && (
          <div style={S.overlay}>
            <div style={S.modal}>
              <button style={S.closeX} onClick={closeChangeRoleModal} aria-label="Close">&times;</button>
              <div style={S.modalHead}>
                <span style={S.modalBadge('#d97706')}>
                  <FaExchangeAlt style={{ color:'#fff', fontSize:18 }} />
                </span>
                <span style={S.modalTitle}>Change Role</span>
                <span style={{ ...S.modalSub, marginLeft:6 }}>/ {changeRoleMember.Name || changeRoleMember.name}</span>
              </div>

              <form className="space-y-4" onSubmit={handleChangeRoleSubmit}>
                <div>
                  <label style={S.label}>Select New Role</label>
                  <select
                    style={S.select}
                    value={changeRoleValue}
                    onChange={e => setChangeRoleValue(e.target.value)}
                    disabled={changeRoleLoading}
                  >
                    <option value="">Select Role</option>
                    <option value="System Admin">System Admin</option>
                    <option value="President">President</option>
                    <option value="Vice President">Vice President</option>
                    <option value="Secretary">Secretary</option>
                    <option value="Treasurer">Treasurer</option>
                    <option value="Co - Asst. Secretary">Co - Asst. Secretary</option>
                    <option value="Co - Asst. Treasurer">Co - Asst. Treasurer</option>
                    <option value="Chief Editor">Chief Editor</option>
                    <option value="Club Director">Club Director</option>
                     <option value="Team Head">Team Head</option>
                     <option value="Activity Director">Activity Director</option>
                    <option value="Past President">Past President</option>
                    <option value="President Program Coordinator">President Program Coordinator</option>
                    <option value="Club Performence Evaluator">Club Performence Evaluator</option>
                    <option value="Past Board Member">Past Board Member</option>
                    <option value="IT Department">IT Department</option>
                    <option value="Installation sub-committee member">Installation sub-committee member</option>
                    <option value="Reporting Sub-Committee">Reporting Sub-Committee</option>
                    <option value="Committee Member">Committee Member</option>
                    <option value="Club Member">Club Member</option>
                  </select>
                </div>

                {changeRoleError && <div style={S.errorText}>{changeRoleError}</div>}

                <button type="submit" style={S.warnCTA} disabled={changeRoleLoading}>
                  {changeRoleLoading ? 'Updating...' : 'Update Role'}
                </button>
              </form>
            </div>
          </div>
        )}

        <BanConfirmationModal />
      </main>
    </div>
  );
}
